interface Translation {
  /**
   * i18n key that is passed to the translation service.
   */
  key: string;

  /**
   * Optional parameters that are passed when {@link key} is translated.
   */
  parameters?: Record<string, any>;

  /**
   * Optional parameters that are passed when {@link key} is translated. They will be translated as well.
   */
  parametersToTranslate?: Record<string, Translatable>;
}

/**
 * i18n key or {@link Translation}
 */
export type Translatable = string | Translation;

/**
 * Get the i18n key for the given {@link Translatable}.
 * @param value {string} or {@link Translation}
 */
export function getTranslationKey(value: Translatable): string {
  if (isTranslation(value)) {
    return value.key;
  } else {
    return value;
  }
}

export function resolveTranslation(value: Translatable, parameters?: Record<string, any>): Translation {
  if (isTranslation(value)) {
    return value;
  } else {
    return {
      key: value,
      parameters,
    };
  }
}

/**
 * Returns true if the passed value is a {@link Translation} object.
 */
export function isTranslation(value?: any): value is Translation {
  return value != null && typeof value === 'object' && 'key' in value;
}

export function isTranslatable(value?: any): value is Translatable {
  return isTranslation(value) || typeof value === 'string';
}
